module.exports = __webpack_public_path__ + "7461987330b7258030c8eb4c311609a7.jpg";